// French translations
export const fr = {
  // Navigation
  navigation: {
    dashboard: 'Tableau de bord',
    inventory: 'Inventaire',
    market: 'Marché',
    production: 'Production',
    brands: 'Marques',
    copyright: 'Droits d\'auteur',
    employees: 'Employés',
    machinery: 'Machines',
    productRequests: 'Demande d\'ajout de produit',
    cryptoWallet: 'Portefeuille Crypto',
    gameTitle: 'Jeu Tycoon d\'Entreprise'
  },

  // Dashboard
  dashboard: {
    title: 'Bienvenue dans le Jeu Tycoon d\'Entreprise',
    subtitle: 'Commencez votre voyage économique',
    cashBalance: 'Solde en espèces',
    playerLevel: 'Niveau du joueur',
    experience: 'Expérience',
    production: 'Production de produits',
    productionSubtitle: 'Produire de nouveaux produits',
    market: 'Marché',
    marketSubtitle: 'Vendez vos produits',
    brands: 'Vos marques',
    brandsSubtitle: 'Gérer les marques personnelles',
    copyright: 'Droits d\'auteur',
    copyrightSubtitle: 'Protéger vos produits',
    employees: 'Vos employés',
    employeesSubtitle: 'Gérer les ressources humaines',
    machinery: 'Machines',
    machinerySubtitle: 'Gérer l\'équipement',
    aiRequests: 'Demande d\'ajout de produit',
    aiRequestsSubtitle: 'Demande d\'ajout d\'un nouveau produit au système',
    recentActivity: 'Activité récente',
    recentActivitySubtitle: 'Vos dernières actions',
    viewAll: 'Voir tout',
    produce: 'Produire',
    sell: 'Vendre',
    manage: 'Gérer',
    goldenBrand: 'Marque Dorée',
    reputation: 'Réputation',
    barbariBread: 'Pain Barbari',
    specialBarbariBread: 'Pain Barbari Spécial',
    requests: 'Demandes',
    ahmadMohammadi: 'Ahmad Mohammadi',
    level: 'Niveau',
    breadMachine: 'Machine de Production de Pain',
    excellent: 'Excellent',
    gameStart: 'Début du Jeu',
    accountCreated: 'Votre compte a été créé',
    reachedLevel1: 'Vous avez atteint le niveau 1',
    now: 'Maintenant'
  },


  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    save: 'Sauvegarder',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    name: 'Nom',
    description: 'Description',
    price: 'Prix',
    quantity: 'Quantité',
    total: 'Total',
    yes: 'Oui',
    no: 'Non',
    confirm: 'Confirmer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    reset: 'Réinitialiser',
    select: 'Sélectionner',
    required: 'Requis',
    optional: 'Optionnel',
    player: 'Joueur',
    personal: 'Personnel'
  },

  // Auth
  auth: {
    login: 'Connexion',
    register: 'S\'inscrire',
    logout: 'Déconnexion',
    username: 'Nom d\'utilisateur',
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié',
    rememberMe: 'Se souvenir de moi',
    welcomeBack: 'Bon retour',
    createAccount: 'Créer un compte',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    dontHaveAccount: 'Vous n\'avez pas de compte ?'
  },

  // Copyright
  copyright: {
    title: 'Gestion des droits d\'auteur',
    subtitle: 'Gérez vos demandes de droits d\'auteur',
    selectProduct: 'Sélectionner un produit',
    selectBrand: 'Sélectionner une marque',
    requestMessage: 'Message de demande',
    status: 'Statut',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    createdAt: 'Créé le',
    reviewedAt: 'Examiné le',
    adminResponse: 'Réponse de l\'administrateur',
    yourRequests: 'Vos demandes',
    requests: 'demande',
    protectProducts: 'Protégez vos produits avec les droits d\'auteur',
    noRequests: 'Aucune demande trouvée',
    createRequest: 'Nouvelle demande de droits d\'auteur',
    createRequestSubtitle: 'Demander les droits d\'auteur pour votre produit',
    yourRequestsSubtitle: 'Liste de toutes vos demandes',
    requestMessagePlaceholder: 'Entrez la description de votre demande de droits d\'auteur',
    createFirstRequest: 'Soumettre la première demande',
    benefits: 'Avantages des droits d\'auteur',
    legalProtection: 'Protection légale',
    legalProtectionDescription: 'Protégez vos produits contre la copie illégale',
    additionalRevenue: 'Revenus supplémentaires',
    additionalRevenueDescription: 'Recevez des redevances de ceux qui copient votre produit',
    brandCredibility: 'Crédibilité de la marque',
    brandCredibilityDescription: 'Le droit d\'auteur augmente la crédibilité et la valeur de votre marque',
    legalRight: 'Droit légal',
    legalRightDescription: 'Ayez le droit exclusif d\'utiliser votre produit'
  },

  // Brands
  brands: {
    title: 'Gestion des marques',
    subtitle: 'Gérez vos marques personnelles',
    createBrand: 'Créer une nouvelle marque',
    createBrandSubtitle: 'Définissez votre nouvelle marque',
    brandName: 'Nom de la marque',
    brandNamePlaceholder: 'Entrez le nom de votre marque',
    brandDescription: 'Description de la marque',
    brandDescriptionPlaceholder: 'Entrez la description de votre marque',
    reputation: 'Réputation',
    createdAt: 'Créé le',
    yourBrands: 'Vos marques',
    yourBrandsSubtitle: 'Liste des marques créées',
    brands: 'marque',
    excellent: 'Excellent',
    good: 'Bon',
    average: 'Moyen',
    poor: 'Faible',
    viewProducts: 'Voir les produits',
    noBrands: 'Aucune marque trouvée',
    createFirstBrand: 'Pour commencer, créez votre première marque.',
    brandCreated: 'Marque créée avec succès !',
    brandError: 'Erreur lors de la création de la marque',
    fillRequiredFields: 'Veuillez entrer le nom de la marque'
  },

  // Employees
  employees: {
    title: 'Gestion des employés',
    subtitle: 'Gérez vos employés',
    yourEmployees: 'Vos employés',
    people: 'personnes',
    totalSalary: 'Salaire total',
    production: 'Production',
    sales: 'Ventes',
    management: 'Gestion',
    general: 'Général',
    skillLevel: 'Niveau de compétence',
    salary: 'Salaire',
    experience: 'Expérience',
    efficiency: 'Efficacité',
    hiredAt: 'Embauché le',
    fire: 'Licencier',
    hire: 'Embaucher',
    selectEmployee: 'Sélectionner un employé',
    noEmployees: 'Aucun employé trouvé',
    hireNewEmployee: 'Embaucher un nouvel employé',
    hireNewEmployeeSubtitle: 'Choisissez parmi les employés disponibles',
    yourEmployeesSubtitle: 'Liste de tous les employés',
    statistics: '📊 Statistiques des employés',
    statisticsSubtitle: 'Informations générales sur les employés',
    benefits: 'Avantages d\'embaucher des employés',
    noEmployeesMessage: 'Vous pouvez augmenter votre efficacité en embauchant des employés',
    hireFirstEmployee: 'Embaucher le premier employé',
    employeeCount: 'Nombre d\'employés',
    averageEfficiency: 'Efficacité moyenne',
    productionWorkers: 'Ouvriers de production',
    efficiencyBoost: 'Augmentation de l\'efficacité',
    efficiencyBoostDescription: 'Les employés augmentent votre efficacité de production et de vente',
    specialization: 'Spécialisation',
    specializationDescription: 'Chaque employé se spécialise dans un domaine spécifique',
    experienceGrowth: 'Croissance de l\'expérience',
    experienceGrowthDescription: 'Les employés acquièrent plus d\'expérience avec le temps',
    moreProfit: 'Plus de profit',
    moreProfitDescription: 'Une efficacité plus élevée mène à plus de profit'
  },

  // Machinery
  machinery: {
    title: 'Magasin de machinerie',
    subtitle: 'Gérez votre machinerie',
    yourMachinery: 'Votre machinerie',
    devices: 'appareils',
    allTypes: 'Tous les types',
    production: 'Production',
    transport: 'Transport',
    storage: 'Stockage',
    yourMachineryList: 'Votre machinerie',
    yourMachinerySubtitle: 'Liste de la machinerie achetée',
    noMachinery: 'Aucune machinerie achetée pour le moment',
    noMachineryMessage: 'Augmentez votre efficacité en achetant de la machinerie',
    efficiency: 'Efficacité',
    maintenanceCost: 'Coût de maintenance',
    condition: 'État',
    repair: 'Réparer',
    details: 'Détails',
    level: 'Niveau',
    requiredLevel: 'Niveau requis',
    price: 'Prix',
    insufficientFunds: 'Fonds insuffisants',
    insufficientLevel: 'Niveau insuffisant',
    buy: 'Acheter',
    statistics: '📊 Statistiques de machinerie',
    statisticsSubtitle: 'Informations générales sur la machinerie',
    deviceCount: 'Nombre d\'appareils',
    totalValue: 'Valeur totale',
    productionDevices: 'Appareils de production',
    benefits: 'Avantages de la machinerie',
    benefitsSubtitle: 'Pourquoi devriez-vous acheter de la machinerie ?',
    efficiencyBoost: 'Augmentation de l\'efficacité',
    efficiencyBoostDescription: 'La machinerie augmente l\'efficacité de production et de transport',
    costReduction: 'Réduction des coûts',
    costReductionDescription: 'La machinerie réduit les coûts de production et de transport',
    betterQuality: 'Meilleure qualité',
    betterQualityDescription: 'La machinerie avancée améliore la qualité des produits',
    scalability: 'Évolutivité',
    scalabilityDescription: 'Avec la machinerie, vous pouvez étendre votre production',
    shop: 'Magasin de machinerie',
    buyNewMachinery: 'Acheter de la nouvelle machinerie',
    excellent: 'Excellent',
    good: 'Bon',
    average: 'Moyen',
    poor: 'Faible',
  },

  // Production
  production: {
    title: 'Production',
    loading: 'Chargement...',
    startNewProduction: 'Commencer une nouvelle production',
    startNewProductionSubtitle: 'Produire de nouveaux produits',
    selectProduct: 'Sélectionner un produit',
    seconds: 'secondes',
    productionInfo: 'Informations de production',
    product: 'Produit',
    price: 'Prix',
    productionTime: 'Temps de production',
    requiredLevel: 'Niveau requis',
    startProduction: 'Commencer la production',
    activeProductions: '🔄 Productions actives',
    activeProductionsSubtitle: 'Productions en cours',
    quantity: 'Quantité',
    timeRemaining: 'Temps restant',
    collect: 'Collecter',
    waiting: 'En attente',
    noActiveProductions: 'Aucune production active',
    noActiveProductionsMessage: 'Commencez à produire des produits !',
    availableProducts: '📋 Produits disponibles',
    availableProductsSubtitle: 'Liste de tous les produits produisibles',
    category: 'Catégorie',
    food: 'Nourriture',
    electronics: 'Électronique',
    materials: 'Matériaux',
    textiles: 'Textiles',
    chemicals: 'Chimiques',
    construction: 'Construction'
  },

  // Market
  market: {
    title: 'Marché',
    loading: 'Chargement...',
    subtitle: 'Vendez vos produits aux magasins',
    demand: 'Demande',
    location: 'Emplacement',
    sellableProducts: 'Produits vendables',
    shop: 'Magasin',
    basePrice: 'Prix de base',
    shopInterest: 'Intérêt du magasin',
    priceMultiplier: 'Multiplicateur de prix',
    sell: 'Vendre',
    noProducts: 'Ce magasin n\'achète aucun produit',
    statistics: 'Statistiques du marché',
    statisticsSubtitle: 'Informations générales du marché',
    activeShops: 'Magasins actifs',
    averageDemand: 'Demande moyenne',
    sellableProductsCount: 'Produits vendables'
  },

  // Inventory
  inventory: {
    title: 'Inventaire',
    subtitle: 'Vos biens produits',
    unknownProduct: 'Produit inconnu',
    quality: 'Qualité',
    quantity: 'Quantité',
    sell: 'Vendre',
    details: 'Détails',
    emptyInventory: 'L\'inventaire est vide',
    emptyInventoryMessage: 'Vous n\'avez encore aucun bien en inventaire. Commencez à produire !',
    startProduction: 'Commencer la production'
  },

  // Product Requests
  productRequests: {
    title: 'Demande d\'ajout de produit',
    subtitle: 'Demande d\'ajout d\'un nouveau produit au système',
    newRequest: 'Nouvelle demande de produit',
    newRequestSubtitle: 'Entrez les détails de votre nouveau produit',
    productName: 'Nom du produit',
    productNamePlaceholder: 'ex: Pain Barbari spécial',
    category: 'Catégorie',
    selectCategory: 'Sélectionner une catégorie',
    targetPrice: 'Prix cible',
    targetPricePlaceholder: 'Prix suggéré du produit',
    description: 'Description',
    descriptionPlaceholder: 'Description complète du produit',
    requiredMaterials: 'Matériaux requis',
    requiredMaterialsPlaceholder: 'Liste des matériaux nécessaires à la production',
    requiredMachinery: 'Machines requises',
    requiredMachineryPlaceholder: 'Liste des machines nécessaires à la production',
    productionProcess: 'Processus de production',
    productionProcessPlaceholder: 'Étapes de production du produit dans l\'ordre',
    estimatedProductionTime: 'Temps de production estimé',
    estimatedProductionTimePlaceholder: 'Temps requis pour la production (minutes)',
    submitRequest: 'Soumettre la demande',
    fillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
    requestSubmitted: 'Votre demande a été soumise avec succès !',
    submitError: 'Erreur lors de la soumission de la demande',
    yourRequests: 'Vos demandes',
    yourRequestsSubtitle: 'Liste des demandes soumises',
    totalRequests: 'Total des demandes',
    approvedRequests: 'Demandes approuvées',
    pending: 'En attente',
    underReview: 'En cours d\'examen',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    createdAt: 'Créé le',
    reviewedAt: 'Examiné le',
    adminNotes: 'Notes de l\'administrateur',
    minutes: 'minutes',
    noRequests: 'Aucune demande trouvée',
    addAtLeastOneMaterial: 'Veuillez ajouter au moins un matériau',
    addAtLeastOneMachinery: 'Veuillez ajouter au moins une machinerie',
    selectExistingMaterial: 'Sélectionner un matériau existant',
    selectMaterial: 'Sélectionner un matériau',
    materialName: 'Nom du matériau',
    materialNamePlaceholder: 'Nom du matériau',
    quantity: 'Quantité',
    unit: 'Unité',
    unitPlaceholder: 'kg, litre, pièce',
    addMaterial: 'Ajouter un matériau',
    selectExistingMachinery: 'Sélectionner une machinerie existante',
    selectMachinery: 'Sélectionner une machinerie',
    machineryName: 'Nom de la machinerie',
    machineryNamePlaceholder: 'Nom de la machinerie',
    addMachinery: 'Ajouter une machinerie',
    new: 'Nouveau',
    food: 'Alimentation',
    electronics: 'Électronique',
    materials: 'Matériaux',
    textiles: 'Textiles',
    chemicals: 'Chimiques',
    construction: 'Construction'
  },

  // Crypto Wallet
  crypto: {
    title: 'Système de cryptomonnaie',
    subtitle: 'Gérez les portefeuilles et les jetons personnels',
    wallets: 'Portefeuilles',
    tokens: 'Jetons',
    transactions: 'Transactions',
    staking: 'Staking',
    createWallet: 'Créer un portefeuille',
    createToken: 'Créer un jeton',
    yourWallets: 'Vos portefeuilles',
    walletsSubtitle: 'Liste des portefeuilles personnels',
    yourTokens: 'Vos jetons',
    tokensSubtitle: 'Liste des jetons créés',
    yourTransactions: 'Vos transactions',
    transactionsSubtitle: 'Historique des transactions',
    stakingPools: 'Pools de staking',
    stakingSubtitle: 'Stakez des jetons pour gagner des récompenses',
    noWallets: 'Aucun portefeuille créé',
    noWalletsMessage: 'Pour commencer, créez un nouveau portefeuille.',
    noTokens: 'Aucun jeton créé',
    noTokensMessage: 'Pour commencer, créez un nouveau jeton.',
    noTransactions: 'Aucune transaction trouvée',
    noTransactionsMessage: 'Vous n\'avez pas encore effectué de transaction.',
    walletName: 'Nom du portefeuille',
    walletNamePlaceholder: 'Entrez le nom de votre portefeuille',
    tokenName: 'Nom du jeton',
    tokenNamePlaceholder: 'Entrez le nom de votre jeton',
    tokenSymbol: 'Symbole du jeton',
    tokenSymbolPlaceholder: 'ex., BTC, ETH',
    totalSupply: 'Offre totale',
    totalSupplyPlaceholder: 'Nombre total de jetons',
    walletCreated: 'Portefeuille créé avec succès !',
    tokenCreated: 'Jeton créé avec succès !',
    walletError: 'Erreur lors de la création du portefeuille',
    tokenError: 'Erreur lors de la création du jeton',
    balance: 'Solde',
    address: 'Adresse',
    symbol: 'Symbole',
    supply: 'Offre',
    price: 'Prix',
    marketCap: 'Capitalisation',
    volume: 'Volume',
    change24h: 'Changement 24h',
    buy: 'Acheter',
    sell: 'Vendre',
    transfer: 'Transférer',
    stake: 'Staker',
    unstake: 'Déstaker',
    amount: 'Montant',
    amountPlaceholder: 'Entrez le montant',
    recipient: 'Destinataire',
    recipientPlaceholder: 'Adresse du destinataire',
    stakeAmount: 'Montant à staker',
    stakeAmountPlaceholder: 'Montant de jetons à staker',
    stakePeriod: 'Période de staking',
    stakePeriodPlaceholder: 'Jours',
    apy: 'APY',
    totalStaked: 'Total staké',
    yourStake: 'Votre stake',
    rewards: 'Récompenses',
    claimRewards: 'Réclamer les récompenses',
    walletBalance: 'Solde du portefeuille',
    totalValue: 'Valeur totale',
    portfolio: 'Portefeuille',
    portfolioSubtitle: 'Aperçu de vos investissements',
    fillRequiredFields: 'Veuillez remplir tous les champs requis',
    createWalletSubtitle: 'Créez votre nouveau portefeuille',
    createTokenSubtitle: 'Créez votre nouveau jeton',
    transferSubtitle: 'Transférer des jetons vers un autre portefeuille',
    selectToken: 'Sélectionner un jeton',
    tokenDescription: 'Description du jeton',
    tokenDescriptionPlaceholder: 'Entrez la description de votre jeton',
    initialPrice: 'Prix initial',
    initialPricePlaceholder: 'Prix initial du jeton',
    tokenLogoUrl: 'URL du logo du jeton',
    tokenLogoUrlPlaceholder: 'URL de l\'image du logo du jeton',
    viewDetails: 'Voir les détails',
    selectWalletFirst: 'Veuillez d\'abord sélectionner un portefeuille',
    stakingComingSoon: 'Staking bientôt disponible',
    stakingDescription: 'La fonctionnalité de staking de jetons sera bientôt ajoutée',
    transferSuccess: 'Transfert effectué avec succès !',
    transferError: 'Erreur lors du transfert'
  }
}
